import { localStorageGetItem, localStorageRemoveItem, localStorageSetItem } from "../components/storage/localStorageManager";
import { SocialEnumKeyType } from "../types/auth";

export const authType = {
    getAuthType: function () {
        const authType = localStorageGetItem('authType');
        return authType || '';
    },

    setAuthType: function (authType: SocialEnumKeyType) {
        localStorageSetItem('authType', authType);
    },

    removeAuthType: function () {
        if (this.getAuthType()) {
            localStorageRemoveItem('authType');
        }
    },
};
